/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import Euslugi from './Euslugi';
import ServicesLayout from '../../components/ServicesLayout';

const MainRoute = {
  path: '/',
  action(ctx) {
    return {
      component: <ServicesLayout active="catalogue"><Euslugi /></ServicesLayout>,
      description: "Inspire Hub - Platforma do publikacji danych przestrzennych dla gmin",
    };
  },
};
/* eslint-disable global-require*/
export default {
  path: '/euslugi',
  children: [
    MainRoute,
    require('./szczegolyEuslugi').default,
  ],
};



// WEBPACK FOOTER //
// src/routes/euslugi/index.js